import React from 'react'
import { Box, makeStyles, Toolbar } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { LocalGridFragment } from '../../generated/graphql'
import { SystemContainerDrawer } from '../system-container/SystemContainerDrawer'
import {
  SystemContainerHeader,
  useHeaderStyles,
} from '../system-container/SystemContainerHeader'
import { Sidebar } from '../layout/Sidebar'
import { SystemContainerSidebarContent } from '../system-container/sidebar/SystemContainerSidebarContent'
import { LocalGridDrawerContent } from './LocalGridDrawerContent'
import {
  calculatorVar,
  comparisonVersionCalculatorVar,
} from '../../apollo/reactive-vars'
import { localGridResultCategories } from '../../provider/result-categories'

const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
  },
})

type Props = {
  localGrid?: LocalGridFragment
  onClose: () => void
}

export function LocalGridDrawer({
  localGrid,
  onClose,
}: Props): React.ReactElement {
  const classes = useStyles()
  const headerClasses = useHeaderStyles()
  const { t } = useTranslation()
  const calculator = useReactiveVar(calculatorVar)
  const comparisonCalculator = useReactiveVar(comparisonVersionCalculatorVar)

  const containers =
    calculator
      ?.getLocalGrids()
      .filter(
        (localGridCalculator) => localGridCalculator.id === localGrid?.id,
      ) ?? []
  const comparisonContainers =
    comparisonCalculator
      ?.getLocalGrids()
      .filter(
        (localGridCalculator) => localGridCalculator.type === localGrid?.type,
      ) ?? undefined

  return (
    <SystemContainerDrawer isOpen={localGrid !== undefined} onClose={onClose}>
      <SystemContainerHeader
        closeLabel={t(`localGrid.${localGrid?.type ?? ''}.close`)}
        onClose={onClose}
        containerName={
          localGrid?.type ? t(`localGridType.${localGrid?.type}`) : ''
        }
      />

      {localGrid && (
        <Box display="flex">
          <Sidebar isExtended={comparisonContainers !== undefined}>
            {/* Allocate space for app bar. */}
            <Toolbar className={headerClasses.toolbar} />

            <SystemContainerSidebarContent
              containers={containers}
              comparisonContainers={comparisonContainers}
              resultCategories={localGridResultCategories}
            />
          </Sidebar>

          <main className={classes.content}>
            {/* Allocate space for app bar. */}
            <Toolbar className={headerClasses.toolbar} />

            <Box flexGrow={1}>
              <LocalGridDrawerContent localGrid={localGrid} onClose={onClose} />
            </Box>
          </main>
        </Box>
      )}
    </SystemContainerDrawer>
  )
}
